export class OverflowGroup {
  visible = new Set<string>();
  overflow = new Set<string>();

  constructor(public max: number) {}

  clone(): OverflowGroup {
    const next = new OverflowGroup(this.max);

    next.visible = new Set(this.visible);
    next.overflow = new Set(this.overflow);

    return next;
  }

  remove(appId: string) {
    if (this.has(appId)) {
      if (this.overflow.has(appId)) {
        this.overflow.delete(appId);
      }
      this.visible.delete(appId);
      if (this.visible.size < this.max && this.overflow.size > 0) {
        const bump = Array.from(this.overflow)[0];
        this.overflow.delete(bump);
        this.visible.add(bump);
      }
    }
  }

  addVisible(appId: string) {
    if (this.visible.size < this.max) {
      this.visible.add(appId);
    } else {
      const bump = Array.from(this.visible)[0];
      this.visible.delete(bump);
      this.overflow.add(bump);
      this.visible.add(appId);
    }
  }

  add(appId: string) {
    if (!this.has(appId)) {
      this.addVisible(appId);
    }
  }

  show(appId: string) {
    if (!this.visible.has(appId)) {
      this.overflow.delete(appId);
      this.addVisible(appId);
    }
  }

  addOrShow(appId: string) {
    if (this.has(appId)) {
      this.show(appId);
    } else {
      this.addVisible(appId);
    }
  }

  all() {
    return new Set([...this.visible, ...this.overflow]);
  }

  has(appId: string) {
    return this.visible.has(appId) || this.overflow.has(appId);
  }
}
